import { HStack, useBreakpointValue, VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Text } from "@repo/core/components/core/Text";
import { Image } from "@gluestack-ui/themed";
import { ProposalProductSectionProps } from "./types";
import GenericCardImage from "@repo/core/assets/images/generic-card.jpg";

export const ProposalProductSection = ({
  name,
  description,
  cardNumber,
  image = GenericCardImage,
  isShowEditButton,
  onPressChangeProduct
}: ProposalProductSectionProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <VStack flex={1} gap="$2">
      <Text fontSize="$xs" fontWeight={500} color="$textLight700">
        Produto
      </Text>
      <VStack
        p="$2"
        borderWidth={1}
        borderRadius="$lg"
        bg="$backgroundLight50"
        borderColor="$borderLight100"
      >
        <HStack gap="$3">
          <VStack alignItems="center" justifyContent="center">
            <Image
              w="$24"
              h="$16"
              alt="Avatar"
              source={image}
              borderColor={"$borderLight300"}
            />
          </VStack>
          <VStack justifyContent="center" flex={1} gap="$1">
            <Text fontSize="$sm" fontWeight={600} color="$textLight900">
              {name}
            </Text>
            <Text fontSize="$xs" fontWeight={500} color="$textLight800">
              {description}
            </Text>
            <Text fontSize="$xs" fontWeight={500} color="$textLight800">
              {cardNumber}
            </Text>
          </VStack>

          {!isMobile && isShowEditButton && (
            <Button
              variant="outline"
              action="secondary"
              size="md"
              text="Alterar"
              leftIcon={{
                name: "pen-square",
                color: "$secondary900",
                size: 20
              }}
              onPress={onPressChangeProduct}
            />
          )}
        </HStack>
      </VStack>
      {isMobile && isShowEditButton && (
        <Button
          variant="outline"
          action="secondary"
          size="md"
          text="Alterar Produto"
          leftIcon={{
            name: "pen-square",
            color: "$secondary900",
            size: 20
          }}
          onPress={onPressChangeProduct}
        />
      )}
    </VStack>
  );
};
